import {
    inject,
    Injectable
} from '@angular/core';

import {
    restManager
} from 'app/ajs-upgraded-providers';

import {
    GetFoliosResponse,
    BedzzleCommonTransaction,
    BedzzleCommonFolio
} from 'src/app/features/digital-payments';

export type BeddyFolio = BedzzleCommonFolio &{
    checkInStatus?: number,
    checkOutStatus?: number
}

@Injectable({
    providedIn: 'root'
})
export class BeddyApiService {
    private readonly restManager = inject(restManager);

    public setupShop(paymentMethodId: number,propertyId: string): Promise<any> {
        return this.restManager.post('beddy/setup', { propertyId: propertyId }, { tilbyPaymentId: paymentMethodId });
    }

    public getRoomFolios(paymentMethodId: number): Promise<GetFoliosResponse<BeddyFolio>> {
        return this.restManager.getList('beddy/room_folios', { tilbyPaymentId: paymentMethodId });
    }

    public createTransaction(paymentMethodId: number, transactionData: BedzzleCommonTransaction) {
        return this.restManager.post('beddy/transactions', transactionData, { tilbyPaymentId: paymentMethodId });
    }

    public rollbackTransaction(paymentMethodId: number, outletId: string, orderId: string) {
        return this.restManager.deleteOne('beddy/transactions', null, { orderId: orderId, outletId: outletId, tilbyPaymentId: paymentMethodId });
    }
}